import type { LucideIcon } from 'lucide-react';
import styles from '../igrow.module.css';

type AreaCardProps = {
  name: string;
  subtitle: string;
  background: string;
  accent: string;
  icon: LucideIcon;
  checked: boolean;
  onToggle: () => void;
};

export default function AreaCard({
  name,
  subtitle,
  background,
  accent,
  icon: Icon,
  checked,
  onToggle,
}: AreaCardProps) {
  const inputId = `area-${name.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}`;

  return (
    <label
      className={styles.areaCard}
      htmlFor={inputId}
      style={{ ['--area-bg' as string]: background, ['--area-accent' as string]: accent }}
    >
      <input
        id={inputId}
        className={styles.visuallyHidden}
        type="checkbox"
        name="areas"
        value={name}
        checked={checked}
        onChange={onToggle}
      />
      <span className={`${styles.tick} ${styles.areaTick}`} aria-hidden="true">
        <svg className={styles.check} viewBox="0 0 12 12" fill="none">
          <path d="M2.2 6.2 4.7 8.7 9.8 3.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      <span className={styles.areaIcon}>
        <Icon size={36} strokeWidth={1.75} aria-hidden="true" />
      </span>
      <span className={styles.areaTitle}>{name}</span>
      <span className={styles.areaSubtitle}>{subtitle}</span>
    </label>
  );
}
